module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_zh-hant-08b5b8602ea1239a2b79d0cf9b51e9b1.jpg";